// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C05: formal onboarding editor. Scoped away from registers and public signing. */
.rcti-agreements.rcti-designed .rcti-agreements__content.agreement-editor-page {
  max-width: 1440px;
  padding: var(--space-8);
  gap: var(--space-6);
}
.agreement-editor-page .rcti-design-breadcrumb {
  display: none;
}
.agreement-editor-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
}
.agreement-editor-columns {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);
  gap: var(--space-6);
  align-items: start;
}
.agreement-editor-stack {
  display: grid;
  gap: var(--space-6);
  min-width: 0;
}
.agreement-editor-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
}
.agreement-editor-page .rcti-agreement-card {
  padding: var(--space-6);
  gap: var(--space-4);
}
.agreement-editor-page .rcti-agreement-card h2 {
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
}
.agreement-editor-page .rcti-agreement-card label {
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
}
.agreement-editor-page .rcti-agreement-card p {
  font-size: var(--font-size-caption-md);
  line-height: 1.6;
}
.agreement-editor-page .rcti-consent {
  display: flex;
  font-weight: var(--font-weight-regular);
}
.agreement-editor-required {
  color: var(--danger-text);
}
.agreement-editor-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-4);
  font-size: var(--font-size-caption-md);
}
.agreement-editor-term-text {
  color: var(--text-primary);
  font-size: var(--font-size-body-sm);
  white-space: pre-line;
  line-height: 1.85;
}
.agreement-editor-note {
  display: grid;
  gap: var(--space-3);
  padding: var(--space-4);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  background: var(--surface-secondary);
  font-size: var(--font-size-caption-md);
}
.agreement-editor-note p {
  font-size: var(--font-size-caption-md);
}
.agreement-editor-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-default);
}
.agreement-editor-footer > div {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}
.agreement-editor-page input[readonly] {
  color: var(--text-primary);
}
@media (max-width: 900px) {
  .agreement-editor-columns {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .rcti-agreements.rcti-designed
    .rcti-agreements__content.agreement-editor-page {
    padding: var(--space-5) var(--space-4);
  }
  .agreement-editor-fields {
    grid-template-columns: 1fr;
  }
  .agreement-editor-page .rcti-design-heading {
    align-items: flex-start;
  }
  .agreement-editor-footer {
    position: static;
  }
  .agreement-editor-footer > div {
    width: 100%;
  }
  .agreement-editor-footer > div > button {
    flex: 1 1 160px;
  }
}

.rcti-agreements
  .agreement-editor-page
  .rcti-design-heading
  > button.rcti-button-secondary {
  color: var(--text-primary);
  background: var(--surface-primary);
}
.agreement-editor-term-text {
  padding-left: var(--space-5);
}
.agreement-editor-term-text li + li {
  margin-top: var(--space-3);
}

.agreement-editor-page .quotation-figma-dropdown {
  position: relative;
  width: 100%;
}
.agreement-editor-page .quotation-figma-dropdown.is-open {
  z-index: 1300;
}
.agreement-editor-page .quotation-figma-dropdown-trigger {
  justify-content: space-between;
  text-align: left;
  height: 40px;
  border-radius: var(--radius-md, 8px);
  border-color: var(--border-default);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: 400 14px var(--font-family-primary);
}
.agreement-editor-page .quotation-figma-dropdown-option {
  justify-content: space-between;
  text-align: left;
}
.agreement-editor-page .quotation-figma-dropdown-option > span:first-child {
  flex: 1 1;
  text-align: left;
}
.agreement-editor-page .quotation-figma-dropdown-menu {
  z-index: 1300 !important;
  max-height: 240px;
  overflow-y: auto;
  border-color: var(--border-default);
  background: var(--surface-primary);
}
.rcti-agreements__content .agreement-saved-setup {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-5);
}
.agreement-saved-setup > div {
  display: grid;
  gap: var(--space-2);
  flex: 1 1 280px;
}
.agreement-saved-setup small {
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.rcti-agreements__content .agreement-resume-setup {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--interactive-default);
  white-space: nowrap;
  text-decoration: none;
}
.rcti-agreements__content .agreement-resume-setup:hover {
  background: var(--surface-secondary);
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/agreementEditor.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uCAAuC;AACzC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;;IAEE,sCAAsC;EACxC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;;AAEA;;;;EAIE,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,iCAAiC;EACjC,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB","sourcesContent":["/* C05: formal onboarding editor. Scoped away from registers and public signing. */\n.rcti-agreements.rcti-designed .rcti-agreements__content.agreement-editor-page {\n  max-width: 1440px;\n  padding: var(--space-8);\n  gap: var(--space-6);\n}\n.agreement-editor-page .rcti-design-breadcrumb {\n  display: none;\n}\n.agreement-editor-status {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-3);\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n}\n.agreement-editor-columns {\n  display: grid;\n  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n.agreement-editor-stack {\n  display: grid;\n  gap: var(--space-6);\n  min-width: 0;\n}\n.agreement-editor-fields {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-4);\n}\n.agreement-editor-page .rcti-agreement-card {\n  padding: var(--space-6);\n  gap: var(--space-4);\n}\n.agreement-editor-page .rcti-agreement-card h2 {\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-editor-page .rcti-agreement-card label {\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-editor-page .rcti-agreement-card p {\n  font-size: var(--font-size-caption-md);\n  line-height: 1.6;\n}\n.agreement-editor-page .rcti-consent {\n  display: flex;\n  font-weight: var(--font-weight-regular);\n}\n.agreement-editor-required {\n  color: var(--danger-text);\n}\n.agreement-editor-links {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-4);\n  font-size: var(--font-size-caption-md);\n}\n.agreement-editor-term-text {\n  color: var(--text-primary);\n  font-size: var(--font-size-body-sm);\n  white-space: pre-line;\n  line-height: 1.85;\n}\n.agreement-editor-note {\n  display: grid;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  background: var(--surface-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.agreement-editor-note p {\n  font-size: var(--font-size-caption-md);\n}\n.agreement-editor-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3);\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--border-default);\n}\n.agreement-editor-footer > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n}\n.agreement-editor-page input[readonly] {\n  color: var(--text-primary);\n}\n@media (max-width: 900px) {\n  .agreement-editor-columns {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 600px) {\n  .rcti-agreements.rcti-designed\n    .rcti-agreements__content.agreement-editor-page {\n    padding: var(--space-5) var(--space-4);\n  }\n  .agreement-editor-fields {\n    grid-template-columns: 1fr;\n  }\n  .agreement-editor-page .rcti-design-heading {\n    align-items: flex-start;\n  }\n  .agreement-editor-footer {\n    position: static;\n  }\n  .agreement-editor-footer > div {\n    width: 100%;\n  }\n  .agreement-editor-footer > div > button {\n    flex: 1 1 160px;\n  }\n}\n\n.rcti-agreements\n  .agreement-editor-page\n  .rcti-design-heading\n  > button.rcti-button-secondary {\n  color: var(--text-primary);\n  background: var(--surface-primary);\n}\n.agreement-editor-term-text {\n  padding-left: var(--space-5);\n}\n.agreement-editor-term-text li + li {\n  margin-top: var(--space-3);\n}\n\n.agreement-editor-page .quotation-figma-dropdown {\n  position: relative;\n  width: 100%;\n}\n.agreement-editor-page .quotation-figma-dropdown.is-open {\n  z-index: 1300;\n}\n.agreement-editor-page .quotation-figma-dropdown-trigger {\n  justify-content: space-between;\n  text-align: left;\n  height: 40px;\n  border-radius: var(--radius-md, 8px);\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: 400 14px var(--font-family-primary);\n}\n.agreement-editor-page .quotation-figma-dropdown-option {\n  justify-content: space-between;\n  text-align: left;\n}\n.agreement-editor-page .quotation-figma-dropdown-option > span:first-child {\n  flex: 1;\n  text-align: left;\n}\n.agreement-editor-page .quotation-figma-dropdown-menu {\n  z-index: 1300 !important;\n  max-height: 240px;\n  overflow-y: auto;\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n}\n.rcti-agreements__content .agreement-saved-setup {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-5);\n}\n.agreement-saved-setup > div {\n  display: grid;\n  gap: var(--space-2);\n  flex: 1 1 280px;\n}\n.agreement-saved-setup small {\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.rcti-agreements__content .agreement-resume-setup {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-3) var(--space-4);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--interactive-default);\n  white-space: nowrap;\n  text-decoration: none;\n}\n.rcti-agreements__content .agreement-resume-setup:hover {\n  background: var(--surface-secondary);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
